// extracted by mini-css-extract-plugin
export default {"alignedRight":"alignedRight__fgmKr","noStyle":"noStyle__2bXSo","indicator":"indicator__frgG2","trigger":"trigger__PjoNz"};